import {
    AnalyticsEvent,
    EVENT_UAEVENT,
    GTMEventData,
} from "@hermes/utils/analytics";

import { EVENT_PRODUCT_GRID, FILTERS } from "../constants/grid.constant";
import { PriceRange } from "../model/grid.model";

export class GridFilterPriceChangedEvent
    implements AnalyticsEvent<GTMEventData>
{
    public name: string = EVENT_UAEVENT;
    public eventData: PriceRange;

    constructor(prices: PriceRange) {
        this.eventData = prices;
    }

    public formatForGTM(): GTMEventData {
        return {
            event: this.name,
            eventcategory: EVENT_PRODUCT_GRID,
            eventaction: FILTERS,
            eventlabel: `Price_${this.eventData.valueMinCurrent}|${this.eventData.valueMaxCurrent}`,
        };
    }
}
